import { usePermissions } from "../../hooks/usePermissions"; // Round DI-1
import React, {
  useState,
  useEffect,
  useRef,
  useMemo,
  useCallback,
} from "react";
import {
  Row,
  CardBody,
  Card,
  Button,
  Modal,
  ModalBody,
  ModalHeader,
  Container,
  Input,
  Form,
  UncontrolledTooltip,
  Badge,
} from "reactstrap";
// UAT Test 11 ROOT-CAUSE FIX: the DI module calls toast.error/success
// dozens of times (including "Please do not skip an entry.") but never
// mounted a ToastContainer — the app has no global one (each page mounts
// its own, e.g. Mafia-Aux, Visitors) — so NO DI toast was ever visible.
// The container is mounted below, scoped to this page only.
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import InspectionSection from "./Inspection/InspectionSection";
import DIHeaderBar from "./DIHeaderBar";
import NewLotModal from "./NewLotModal";
import "./di-theme.css";
import { MafiaPageHeader } from "../Mafia/_shared";
import api from "../../api";
import { useNavigate } from "react-router-dom";
import useAuth from "../Personal Attendance/useAuth";

import usflag from "../../assets/images/usflag.png";
// Round DI-Country — India Database restored (see RELEASE_NOTES): the
// flag import removed by the remove-india round comes back, and the
// session-country pin keeps every workspace call on the selected DB.
import indiaflag from "../../assets/images/indiaflag.png";
import {
  setDICountry,
  clearDICountry,
  diCountryLabel,
} from "./diCountry";
import add from "../../assets/images/add.png";
import excel from "../../assets/images/excel.png";
import leftarrow from "../../assets/images/leftarrow.png";
import rightarrow from "../../assets/images/rightarrow.png";

import * as XLSX from "xlsx";

const DI = () => {
  document.title = "SSW Technologies Dashboard";

  const inspectionRef = useRef(null);
  const detailsRequestSeqRef = useRef(0);
  const submitSeqRef = useRef(0);
  const requestCacheRef = useRef(new Map());

  const [placeholder, setPlaceholder] = useState("");
  const [inputJob, setInputJob] = useState("");
  const [debouncedInputJob, setDebouncedInputJob] = useState("");
  const [inputOption, setInputOption] = useState("");

  // Batch 2 / Round 7 — Job-Lot workflow state (legacy cboJobLot +
  // frmLotNum). lotOptions mirrors the dropdown items (existing lots
  // from the server); selectedLot is the chosen lot as a string;
  // NEW_LOT_SENTINEL is the legacy "New Lot #" first item.
  const NEW_LOT_SENTINEL = "New Lot #";
  const [lotOptions, setLotOptions] = useState([]);
  const [selectedLot, setSelectedLot] = useState("");
  const [showNewLotModal, setShowNewLotModal] = useState(false);

  // ── Part Number workflow (team request) — option "4" ──
  // Parts with no Job/PO/Job Lot but with critical characteristics that
  // must still be inspected. partModeQty is the user-typed "Quantity to
  // Inspect" (there is no Epicor quantity for these parts) — visible and
  // required ONLY in Part Number mode, positive integer, re-validated
  // server-side. partLookupMsg is the inline lookup feedback (latest
  // released MAFIA found / "No released MAFIA table was found for part
  // X.") so the user isn't left staring at a disabled button.
  const [partModeQty, setPartModeQty] = useState("");
  const [partLookupMsg, setPartLookupMsg] = useState(null); // {type:'info'|'error', text}
  // Round 20/21 — reopen UX: existing part-only inspection runs returned
  // by load-job-details ([{wave, lot, quantity, closed}], newest lot
  // first) and the user's selection in the run dropdown: either the LOT
  // (as a string) of the specific inspection to continue, or "new" to
  // start a fresh run (Quantity to Inspect is then asked again).
  const [partRuns, setPartRuns] = useState([]);
  const [partModeChoice, setPartModeChoice] = useState("");

  const [PartNumber, setPartNumber] = useState("");
  const [PartOptions, setPartOptions] = useState([]);

  const [AssemblyNumber, setAssemblyNumber] = useState("");
  const [AssemblyOptions, setAssemblyOptions] = useState([]);

  const [modal_center, setmodal_center] = useState(false);
  const [modaloneerror, setmodaloneerror] = useState("");

  const [countrycode, setcountrycode] = useState("");
  // ── Round DI-Country — dual-database selection state ──
  // selectedCountry: the database group the user is working in ("USA" /
  // "INDIA"). Defaults to the profile country (getcountrycode) and is
  // changed by clicking a button in the other database group. It drives
  // EVERY lookup (load-job-details, get-lots) and, once an inspection
  // starts, is confirmed by the server's EffectiveCountry and pinned as
  // the X-DI-Country session header for all workspace calls.
  // detailsCountry: the server-confirmed country that produced the
  // CURRENT lookup results — lets the Start buttons detect "details
  // loaded under USA, India clicked" and re-look-up before starting.
  const [selectedCountry, setSelectedCountry] = useState("");
  const [detailsCountry, setDetailsCountry] = useState("");
  const [userDetails, setUserDetails] = useState();

  const [wavenumber, setWaveNumber] = useState("");
  const [partquantity, setPartQuantity] = useState("");
  const [vantagenumber, setVantageNumber] = useState("");
  const [origquantity, setOriginalQuantity] = useState("");

  const [revmajor, setRevMajor] = useState();
  const [revMinor, setRevMinor] = useState();

  const [showInspection, setShowInspection] = useState(false);
  const navigate = useNavigate();
  // Round DI-2 — role flags no longer drive any DI visibility; everything
  // is permission-gated (di.supervisorOverride / di.changeLog / app.di).
  useAuth();
  // Round DI-1 — Change Log access is permission-driven ("DI - Change Log",
  // gate di.changeLog): grant it to the quality-engineer role (or specific
  // people) in Access Management. The log itself is already scoped to the
  // loaded job / PO. IT Admin passes via the gate's fallback.
  const { canAccessModule } = usePermissions();
  const canViewAuditLog = !!(canAccessModule && canAccessModule("di.changeLog"));

  // Round DI-2 — run deletion is a supervisor-override action, so its
  // visibility follows the "DI - Supervisor Override" permission gate
  // (di.supervisorOverride) like every other override control; the backend
  // re-validates the same permission regardless. (Was: hardcoded roles.)
  const canDeletePartRun = !!(
    canAccessModule && canAccessModule("di.supervisorOverride")
  );
  const [showDeleteRunConfirm, setShowDeleteRunConfirm] = useState(false);
  const [deletingPartRun, setDeletingPartRun] = useState(false);

  // Round 22 — one dropdown row per run (a run may have headers in both
  // waves): newest first; date/counts aggregated across the waves.
  const dedupedPartRuns = useMemo(() => {
    const byLot = new Map();
    for (const r of partRuns) {
      const lot = Number(r.lot) || 0;
      const cur = byLot.get(lot) || {
        lot,
        quantity: 0,
        closed: false,
        startedOn: null,
        lastSavedOn: null,
        entryCount: 0,
      };
      cur.quantity = cur.quantity || Number(r.quantity) || 0;
      cur.closed = cur.closed || !!r.closed;
      const so = r.startedOn ? new Date(r.startedOn) : null;
      const lo = r.lastSavedOn ? new Date(r.lastSavedOn) : null;
      if (so && (!cur.startedOn || so < cur.startedOn)) cur.startedOn = so;
      if (lo && (!cur.lastSavedOn || lo > cur.lastSavedOn)) cur.lastSavedOn = lo;
      cur.entryCount = Math.max(cur.entryCount, Number(r.entryCount) || 0);
      byLot.set(lot, cur);
    }
    return [...byLot.values()].sort((a, b) => b.lot - a.lot);
  }, [partRuns]);

  const formatRunDate = useCallback((d) => {
    try {
      const dt = d instanceof Date ? d : new Date(d);
      if (Number.isNaN(dt.getTime())) return "";
      return dt.toLocaleDateString(undefined, {
        month: "2-digit",
        day: "2-digit",
        year: "numeric",
      });
    } catch {
      return "";
    }
  }, []);

  // Round 22 — supervisor delete of the SELECTED inspection run. Backend
  // (inspection/delete-part-inspection) re-validates the role and deletes
  // the run's entries, comments and header in one transaction (audited).
  const deleteSelectedPartRun = useCallback(async () => {
    const lot = Number(partModeChoice);
    if (!Number.isInteger(lot) || lot < 0) return;
    const part = (PartNumber || inputJob || "").trim();
    if (!part) return;

    setDeletingPartRun(true);
    try {
      const res = await api.post("inspection/delete-part-inspection", {
        partNum: part,
        lot,
      });
      if (res?.status === 200 && res?.data === true) {
        toast.success(`Inspection #${lot + 1} deleted.`);
        requestCacheRef.current.clear();
        setPartRuns((prev) => {
          const next = prev.filter((r) => Number(r.lot) !== lot);
          setPartModeChoice(
            next.length > 0
              ? String(Math.max(...next.map((r) => Number(r.lot) || 0)))
              : ""
          );
          return next;
        });
        // If the deleted run is the one open in the workspace, close it —
        // its data no longer exists.
        setInspectionData((prevInsp) => {
          if (
            prevInsp &&
            inputOption === "4" &&
            Number(prevInsp.lotNum) === lot
          ) {
            setShowInspection(false);
            setSetupCollapsed(false);
            setDnaDisplay("");
            return null;
          }
          return prevInsp;
        });
      } else {
        toast.error("Could not delete the inspection. Please try again.");
      }
    } catch (err) {
      const msg =
        err?.response?.data?.error || "Could not delete the inspection.";
      toast.error(msg);
    } finally {
      setDeletingPartRun(false);
      setShowDeleteRunConfirm(false);
    }
  }, [partModeChoice, PartNumber, inputJob, inputOption]);

  // Cleanup: once a job is loaded (showInspection), collapse the big Job
  // Setup picker (Option / Job / database tiles) into a one-line summary so
  // it stops eating ~40% of the screen. User can expand it to change jobs.
  const [setupCollapsed, setSetupCollapsed] = useState(false);
  const [inspectionData, setInspectionData] = useState(null);

  const [loadingDetails, setLoadingDetails] = useState(false);
  const [detailsReady, setDetailsReady] = useState(false);

  // ── Round DI-2 (Issue 9) — leave-guard state ──
  // pendingLeaveHref: an internal <a href> the user clicked while an
  // inspection was open (sidebar / menu / breadcrumb); null when the
  // attempt came from the browser Back button instead (pendingLeaveBack).
  const [showLeaveModal, setShowLeaveModal] = useState(false);
  const [pendingLeaveHref, setPendingLeaveHref] = useState(null);
  const [pendingLeaveBack, setPendingLeaveBack] = useState(false);
  // File → Exit while an inspection is open (goes to the dashboard home
  // after a successful close — predictable, no history-stack math).
  const [pendingLeaveExit, setPendingLeaveExit] = useState(false);
  const [closingInspection, setClosingInspection] = useState(false);
  // Round DI-1/DI-2 — legacy "Error 32" parity ("Cannot close application -
  // please first exit any inspection that you may have open.", MDIParent1
  // FormClosing): closing/reloading the browser tab while an inspection is
  // OPEN triggers the browser's native leave-confirmation (modern browsers
  // show their own standardized wording; custom text is not permitted).
  //
  // Round DI-2 fix (acceptance #32 — no false warnings): the DI-1 guard
  // keyed on detailsReady, which is true as soon as a job LOOKUP succeeds —
  // before any inspection is started — so users got warned with nothing
  // open. Legacy warned only while an inspection form (MdiChildren) was
  // open; the modern equivalent is showInspection.
  useEffect(() => {
    const guard = (e) => {
      if (showInspection) {
        e.preventDefault();
        e.returnValue =
          "An inspection is open. Please exit the inspection before closing.";
        return e.returnValue;
      }
    };
    window.addEventListener("beforeunload", guard);
    return () => window.removeEventListener("beforeunload", guard);
  }, [showInspection]);

  // ── Round DI-2 (Issue 9) — IN-APP navigation guard ──
  // While an inspection is open, clicking any internal link (sidebar,
  // menus, breadcrumbs — all render <a href>) is intercepted at the
  // document capture phase and answered with a controlled modal:
  // "Please close the active inspection before leaving this page."
  // (Stay Here / Close Inspection). External links, new-tab links and
  // in-page anchors are never intercepted; links within /di are allowed.
  useEffect(() => {
    if (!showInspection) return undefined;
    const onClickCapture = (e) => {
      try {
        const a = e.target?.closest?.("a[href]");
        if (!a) return;
        if (a.target === "_blank" || a.hasAttribute("download")) return;
        const href = a.getAttribute("href") || "";
        if (!href || href.startsWith("#")) return;
        if (/^[a-z][a-z0-9+.-]*:/i.test(href) && !href.startsWith("/")) return; // http:, mailto:, tel:, ...
        if (href === "/di" || href.startsWith("/di?") || href.startsWith("/di#")) return;
        e.preventDefault();
        e.stopPropagation();
        setPendingLeaveHref(href);
        setPendingLeaveBack(false);
        setPendingLeaveExit(false);
        setShowLeaveModal(true);
      } catch {
        /* never break navigation handling */
      }
    };
    document.addEventListener("click", onClickCapture, true);
    return () => document.removeEventListener("click", onClickCapture, true);
  }, [showInspection]);

  // Browser BACK while an inspection is open: a same-URL history entry is
  // pushed when the inspection starts; popping it keeps the router on /di
  // (so nothing unmounts) and shows the same controlled modal. "Stay Here"
  // re-arms the sentinel; "Close Inspection" completes the original back
  // navigation after a successful close.
  useEffect(() => {
    if (!showInspection) return undefined;
    try {
      window.history.pushState({ diInspectionGuard: true }, "", window.location.href);
    } catch {
      /* ignore */
    }
    const onPop = () => {
      setPendingLeaveHref(null);
      setPendingLeaveBack(true);
      setPendingLeaveExit(false);
      setShowLeaveModal(true);
    };
    window.addEventListener("popstate", onPop);
    return () => window.removeEventListener("popstate", onPop);
  }, [showInspection]);

  const [submitting, setSubmitting] = useState(false);

  const [dnaDisplay, setDnaDisplay] = useState("");

  const [canCloseOp, setCanCloseOp] = useState(false);
  const [opClosed, setOpClosed] = useState(false);
  const [canCloseJob, setCanCloseJob] = useState(false);
  const [jobClosed, setJobClosed] = useState(false);

  const tog_center = useCallback(() => setmodal_center((v) => !v), []);

  const stableStringify = useCallback((value) => {
    const sortObject = (obj) => {
      if (Array.isArray(obj)) return obj.map(sortObject);
      if (obj && typeof obj === "object") {
        return Object.keys(obj)
          .sort()
          .reduce((acc, key) => {
            acc[key] = sortObject(obj[key]);
            return acc;
          }, {});
      }
      return obj;
    };
    return JSON.stringify(sortObject(value));
  }, []);

  const cachedPost = useCallback(
    async (url, payload) => {
      const key = `${url}::${stableStringify(payload || {})}`;
      if (requestCacheRef.current.has(key)) {
        return requestCacheRef.current.get(key);
      }

      const promise = api.post(url, payload).catch((err) => {
        requestCacheRef.current.delete(key);
        throw err;
      });

      requestCacheRef.current.set(key, promise);
      return promise;
    },
    [stableStringify]
  );

  const resetLookupState = useCallback(() => {
    setDetailsCountry(""); // Round DI-Country: details no longer describe any country
    setAssemblyOptions([]);
    setLotOptions([]);
    setSelectedLot("");
    setPartLookupMsg(null); // Part Number mode: clear inline lookup message
    setPartRuns([]);        // Round 20: clear existing-run info
    setPartModeChoice("");  // Round 21: run selection cleared with the runs
    setAssemblyNumber("");
    setPartOptions([]);
    setPartNumber("");
    setDetailsReady(false);
    setShowInspection(false);
    setSetupCollapsed(false); // cleanup: reopen picker when cleared
    setInspectionData(null);
    setDnaDisplay("");
    setPartQuantity("");
    setVantageNumber("");
    setOriginalQuantity("");
    setRevMajor(undefined);
    setRevMinor(undefined);
    setCanCloseOp(false);
    setOpClosed(false);
    setCanCloseJob(false);
    setJobClosed(false);
  }, []);

  useEffect(() => {
    const authData = sessionStorage.getItem("authUser");
    if (authData) {
      const parsed = JSON.parse(authData);
      const name = parsed?.name || "Guest User";
      const title = parsed?.title || "User";
      const department = parsed?.department || 0;

      const empId =
        parsed?.empID ??
        parsed?.empId ??
        parsed?.employeeId ??
        parsed?.employeeID ??
        null;

      setUserDetails({ name, title, department, empId });
    }
  }, []);

  useEffect(() => {
    const fetchCountryCode = async () => {
      try {
        const response = await api.get("di/getcountrycode");
        if (response.status === 200 || response.status === 201) {
          setcountrycode(`${response.data}`);
          // Round DI-Country: the profile country is the DEFAULT database
          // selection (USA-profile → USA, India-profile → India) — never
          // overriding a selection the user already made.
          setSelectedCountry((prev) => prev || `${response.data}`);
        }
      } catch (error) {
        toast.error(`Error: ${error.message || "Unknown error"}`);
      }
    };
    fetchCountryCode();
  }, []);

  // Round DI-Country — keep the session pin (X-DI-Country header for all
  // di/inspection/attachment requests) in lock-step with the selected
  // database, and clear it when the DI page unmounts so no other visit
  // inherits a stale country.
  useEffect(() => {
    setDICountry(selectedCountry);
  }, [selectedCountry]);
  useEffect(() => () => clearDICountry(), []);

  useEffect(() => {
    const t = setTimeout(() => {
      setDebouncedInputJob(inputJob.trim());
    }, 350);
    return () => clearTimeout(t);
  }, [inputJob]);

  useEffect(() => {
    resetLookupState();
  }, [inputOption, inputJob, resetLookupState]);

  // Batch 2 / Round 7 — legacy filljoblot parity: when the job type is
  // "Job Lot #" and the job number is long enough (legacy: length > 6),
  // load the existing lots and prepend the "New Lot #" item.
  // Round DI-Country: legacy MafiaDB.getLots ran against the CountryCode
  // GLOBAL (PlutoConn per country) — it was never USA-only — so the lot
  // lookup now follows the SELECTED database (USA or India) instead of
  // the previous detected-USA-only condition. MafiaJobHeader exists in
  // both DI databases.
  useEffect(() => {
    const loadLots = async () => {
      if (inputOption !== "3") return;
      if ((debouncedInputJob || "").length <= 6) return;
      if (!selectedCountry) return;

      try {
        const resp = await cachedPost("di/get-lots", {
          jobnum: debouncedInputJob,
          countrycode: selectedCountry,
        });
        const lots = Array.isArray(resp?.data) ? resp.data.map(String) : [];
        setLotOptions(lots);
      } catch {
        setLotOptions([]);
      }
    };
    loadLots();
  }, [inputOption, debouncedInputJob, selectedCountry, cachedPost]);

  const handleSelectChange = useCallback((e) => {
    const value = e.target.value;
    // Part Number mode state never leaks into the other modes (and
    // vice-versa): quantity + inline message are cleared on EVERY switch.
    setPartModeQty("");
    setPartLookupMsg(null);
    if (value === "1") {
      setPlaceholder("Enter Job Number");
      setInputJob("");
      setInputOption("1");
    } else if (value === "2") {
      setPlaceholder("Enter PO\\Line Number");
      setInputJob("");
      setInputOption("2");
    } else if (value === "3") {
      // Batch 2 / Round 7 — legacy "Job Lot #" job type. Same job-number
      // entry as option 1; the lot comes from the lot dropdown.
      setPlaceholder("Enter Job Number");
      setInputJob("");
      setInputOption("3");
    } else if (value === "4") {
      // ── Part Number workflow (team request) ──
      // No Job/PO/Lot: the typed value IS the part number. Switching to
      // this mode clears job-only / PO-only / lot-only state (the
      // inputOption effect runs resetLookupState, which clears lots,
      // assemblies and parts). The Job Lot dropdown is never shown and
      // no PO "\\" validation applies in this mode.
      setPlaceholder("Enter Part Number");
      setInputJob("");
      setInputOption("4");
    } else {
      setPlaceholder("");
      setInputJob("");
      setInputOption("");
    }
  }, []);

  // ── Round DI-Country — lookup body, extracted from the typing effect ──
  // Runs load-job-details under an EXPLICIT country so it can be called
  // both by the effect below (types/pastes → lookup under the selected
  // database) and by handleSubmit when the user clicks a button in the
  // OTHER database group (switch → re-lookup → start, the legacy
  // one-click btnIndia*/btnUSA* flow). Returns the fresh lookup result
  // (never stale React state) so the caller can continue immediately:
  //   { ready, assemblyNumber, partNumber, partOptions, isPartMode }
  const fetchJobDetails = useCallback(
    async (countryForLookup) => {
      const notReady = { ready: false };
      if (!countryForLookup || !inputOption) return notReady;

      if (inputOption === "1" && debouncedInputJob.length < 3) return notReady;
      if (inputOption === "2" && !debouncedInputJob.includes("\\")) {
        // Round 9 batch — legacy MessageBox parity: '\' is REQUIRED,
        // strictly '\' (approved Q10). Warn once the entry is long enough
        // to plausibly be a PO number; stay quiet while they're typing.
        if (debouncedInputJob.trim().length >= 4) {
          setPartLookupMsg({
            type: "error",
            text: "PO\\Line must be entered in the format PO\\Line, for example 0094362\\1.",
          });
        } else {
          setPartLookupMsg(null);
        }
        return notReady;
      }
      if (inputOption === "2") setPartLookupMsg(null);
      // Round 7: Job-Lot uses the normal job lookups (legacy callNewFrm
      // ran GetPartNumber/GetQuantity/GetVantageRev for JobLot too).
      if (inputOption === "3" && debouncedInputJob.length < 3) return notReady;
      // Part Number mode: any non-blank part number is a valid lookup
      // (part numbers can be short). NO Job/PO/assembly/quantity/revision
      // Epicor endpoint is involved — the backend option-"4" branch reads
      // local MafiaTables only.
      if (inputOption === "4" && debouncedInputJob.length < 1) {
        setPartLookupMsg(null);
        return notReady;
      }

      const currentSeq = ++detailsRequestSeqRef.current;
      setLoadingDetails(true);
      setDetailsReady(false);

      try {
        const response = await cachedPost("di/load-job-details", {
          // Round 7: the backend treats Job-Lot exactly like a job-number
          // lookup (legacy parity), so option 3 is sent as "1" here.
          // Part Number mode sends "4" — its own backend branch.
          inputOption: inputOption === "3" ? "1" : inputOption,
          inputJob: debouncedInputJob,
          countrycode: countryForLookup,
        });

        if (currentSeq !== detailsRequestSeqRef.current) return notReady;

        const data = response?.data;
        // Round DI-Country: record which country's database/company the
        // server ACTUALLY used for these details (validated server-side;
        // falls back to the profile country for invalid values).
        setDetailsCountry(data?.effectiveCountry || countryForLookup);
        if (!data?.success) {
          setAssemblyOptions([]);
          setAssemblyNumber("");
          setPartOptions([]);
          setPartNumber("");
          setDetailsReady(false);
          // Part Number mode: show the blocking message inline (e.g.
          // "No released MAFIA table was found for part X.") instead of
          // failing silently — the Start buttons stay disabled.
          if (inputOption === "4") {
            setPartRuns([]);
            setPartModeChoice("");
            setPartLookupMsg(
              data?.errorMessage
                ? { type: "error", text: data.errorMessage }
                : null
            );
          } else {
            // Round DI-1 — owner request: a clear warning card when the
            // typed job / PO isn't in the database (previously the form
            // just stayed inert for non-Part modes).
            setPartLookupMsg({
              type: "error",
              text:
                data?.errorMessage ||
                `No job or PO was found for "${(inputJob || "").trim()}". ` +
                "Please check the number and try again.",
            });
          }
          return notReady;
        }

        // Part Number mode: confirm the latest RELEASED MAFIA that was
        // selected (Drawing Revision = Rev, MAFIA Revision = RevMinor)
        // and capture any existing inspection runs for the reopen UX.
        if (inputOption === "4") {
          const runs = Array.isArray(data?.existingPartInspections)
            ? data.existingPartInspections
            : [];
          setPartRuns(runs);
          // Round 21 — run selector default: the LATEST run's lot (as a
          // string), or "" when the part was never inspected (fresh part).
          setPartModeChoice(
            runs.length > 0
              ? String(Math.max(...runs.map((r) => Number(r.lot) || 0)))
              : ""
          );

          const rj = data?.revMajor;
          const rn = data?.revMinor;
          const eng = (data?.createdBy || "").trim();
          const revText =
            rj != null && rn != null
              ? `Latest released MAFIA found: Rev ${rj}-${rn}${eng ? ` (created by ${eng})` : ""}.`
              : "Latest released MAFIA found.";
          setPartLookupMsg({ type: "info", text: revText });
        } else {
          setPartLookupMsg(null);
        }

        setAssemblyOptions(data.assemblyOptions || []);
        const freshAssembly =
          data.selectedAssembly === null || data.selectedAssembly === undefined
            ? ""
            : `${data.selectedAssembly}`;
        setAssemblyNumber(freshAssembly);

        setPartOptions(data.partOptions || []);
        setPartNumber(data.selectedPart || "");
        setDetailsReady(!!data.detailsReady);

        return {
          ready: !!data.detailsReady,
          assemblyNumber: freshAssembly,
          partNumber: data.selectedPart || "",
          partOptions: data.partOptions || [],
          isPartMode: inputOption === "4",
        };
      } catch (error) {
        if (currentSeq !== detailsRequestSeqRef.current) return notReady;
        setDetailsReady(false);
        setAssemblyOptions([]);
        setAssemblyNumber("");
        setPartOptions([]);
        setPartNumber("");
        toast.error(`Error: ${error.message || "Unknown error"}`);
        return notReady;
      } finally {
        if (currentSeq === detailsRequestSeqRef.current) {
          setLoadingDetails(false);
        }
      }
    },
    [inputOption, debouncedInputJob, inputJob, cachedPost]
  );

  useEffect(() => {
    // Round DI-Country: typing/pasting looks up under the SELECTED
    // database group (profile-country default). Changing the selection
    // re-runs the lookup automatically under the new country.
    fetchJobDetails(selectedCountry);
  }, [fetchJobDetails, selectedCountry]);

  const handleSubmit = useCallback(
    async (e, clickedButton, wave) => {
      e.preventDefault();

      if (submitting) return;

      // ── Round DI-Country — explicit database (country) selection ──
      // The clicked button's country is authoritative (legacy
      // MDIParent1: btnUSA*/btnIndia* forced the CountryCode global
      // before callNewFrm). If it differs from the country whose
      // database produced the CURRENT details, switch safely:
      //   1. never silently discard entered values — flush the open
      //      inspection's pending auto-save first (same guard as
      //      "Change job / settings"); a blocked save stops the switch
      //      with the reason shown;
      //   2. clear the previous country's workspace, lookup caches and
      //      lot state so no USA data can be reused in India mode (or
      //      vice-versa);
      //   3. re-run the lookup under the NEW country and continue with
      //      the FRESH results (never stale state from the old one).
      const targetCountry =
        clickedButton || selectedCountry || countrycode || "USA";
      const switching = targetCountry !== (detailsCountry || selectedCountry);
      let freshDetails = null;

      if (switching) {
        if (showInspection && inspectionRef.current?.hasUnsavedWork?.()) {
          const ok = await inspectionRef.current?.flushAutoSave?.();
          if (!ok) {
            toast.error(
              "Not switched — the current DNA could not be saved. Fix the highlighted issues and try again."
            );
            return;
          }
        }
        // Close the previous-country workspace and drop its cached
        // lookups; the run/lot state belongs to the old database too.
        setShowInspection(false);
        setInspectionData(null);
        setDnaDisplay("");
        requestCacheRef.current.clear();
        setLotOptions([]);
        setSelectedLot("");
        setPartRuns([]);
        setPartModeChoice("");
        setSelectedCountry(targetCountry);
        setDICountry(targetCountry);

        freshDetails = await fetchJobDetails(targetCountry);
        if (!freshDetails?.ready) {
          toast.info(
            `Switched to the ${diCountryLabel(targetCountry)}. No matching details were found there for this entry — please verify the number.`
          );
          return;
        }
        // Part Number mode: the run list / quantity requirement belong
        // to the NEW database and may differ — let the user review the
        // freshly loaded inspection runs, then click Start again.
        if (freshDetails.isPartMode) {
          toast.info(
            `Switched to the ${diCountryLabel(targetCountry)} — review the inspection run selection, then click again to start.`
          );
          return;
        }
      } else if (!detailsReady || loadingDetails) {
        toast.error("Please wait — loading job details...");
        return;
      }

      // Fresh lookup values win over (possibly stale) state when a
      // switch just re-ran the lookup in this same click.
      const effAssembly =
        freshDetails?.assemblyNumber ?? AssemblyNumber;
      const effPartNumber = freshDetails?.partNumber ?? PartNumber;
      const effPartOptions = freshDetails?.partOptions ?? PartOptions;

      // Batch 2 / Round 7 — legacy lot validation (MDIParent1 callNewFrm):
      // in Job-Lot mode a real lot must be selected before continuing.
      let lotForSubmit = 0;
      if (inputOption === "3") {
        if (switching) {
          // The lots list was just cleared and reloads under the new
          // country — a lot from the OLD database must never start a
          // context in the new one.
          setmodaloneerror(
            `Switched to the ${diCountryLabel(targetCountry)} — please select a lot number from the reloaded list before continuing.`
          );
          setmodal_center(true);
          return;
        }
        const lotText = (selectedLot || "").trim();
        if (
          !lotText ||
          lotText === NEW_LOT_SENTINEL ||
          !lotOptions.map((l) => String(l).trim()).includes(lotText)
        ) {
          setmodaloneerror("Please select a lot number before continuing.");
          setmodal_center(true);
          return;
        }
        lotForSubmit = Number(lotText);
      }

      // ── Part Number workflow — run selector (Round 21) ──
      // partModeChoice is either the LOT of the specific inspection to
      // continue (as a string) or "new". Quantity to Inspect is REQUIRED
      // exactly when a fresh run starts: first-ever inspection of the
      // part, or "Start a new inspection" selected. When continuing, the
      // chosen run's stored quantity is reused (the box is hidden, so
      // nothing is silently ignored). Server re-validates all of this,
      // including that the chosen run actually exists.
      let quantityToInspect = null;
      let partRunLot = null;
      const startNewPartInspection =
        inputOption === "4" && partRuns.length > 0 && partModeChoice === "new";
      const partNeedsQty =
        inputOption === "4" &&
        (partRuns.length === 0 || partModeChoice === "new");
      if (inputOption === "4" && partRuns.length > 0 && !startNewPartInspection) {
        const chosen = Number(partModeChoice);
        partRunLot = Number.isInteger(chosen) && chosen >= 0 ? chosen : null;
      }
      if (partNeedsQty) {
        const qtyText = (partModeQty || "").trim();
        const qty = Number(qtyText);
        if (qtyText === "" || !Number.isInteger(qty) || qty <= 0) {
          setmodaloneerror(
            "Please enter the quantity to inspect for this part (a positive whole number)."
          );
          setmodal_center(true);
          return;
        }
        quantityToInspect = qty;
      }

      setWaveNumber(wave);

      if (userDetails?.department === 59 && wave === "1") {
        setmodaloneerror(
          "As a member of the Quality Department, please use the 'Quality' inspection type instead."
        );
        setmodal_center(true);
        return;
      }

      if (userDetails?.department === 76 && wave === "2") {
        setmodaloneerror(
          "As a member of the CNC Department, please use the 'In Process' inspection type instead."
        );
        setmodal_center(true);
        return;
      }

      const currentSubmitSeq = ++submitSeqRef.current;
      setSubmitting(true);

      try {
        // Batch 1 / Round 4: the clicked button's country is now actually
        // SENT (it was accepted as an argument but discarded, so the India
        // buttons silently used the detected country). The backend
        // validates it (only "USA"/"INDIA" honored, profile country
        // otherwise) and routes both the Kinetic company code and the
        // Pluto database accordingly — legacy MDIParent1 parity where
        // btnIndia*/btnUSA* forced CountryCode before callNewFrm.
        const response = await api.post("di/start-inspection-context", {
          // Round 7: Job-Lot submits as a job-number lookup with lotNum.
          // Part Number mode passes "4" through — its own backend branch
          // (local MAFIA only; NO Kinetic/Epicor call; AssemblySeq 0;
          // Lot 0; JobNum key = the part number, documented server-side).
          inputOption: inputOption === "3" ? "1" : inputOption,
          inputJob,
          // Round DI-Country: the clicked button's country — validated
          // server-side (only "USA"/"INDIA" honored) and mapped to a
          // fixed configuration key; the response echoes the effective
          // country actually used, which the workspace then pins.
          countrycode: targetCountry,
          lotNum: inputOption === "4" ? 0 : lotForSubmit,
          waveNumber: wave,
          assemblyNumber: inputOption === "4" ? 0 : Number(effAssembly || 0),
          partNumber: effPartNumber,
          originalPart: effPartOptions?.[0] || effPartNumber,
          // Part Number mode only; null otherwise (ignored server-side).
          quantityToInspect,
          // Round 20: explicit "Start a new inspection" choice (a new run
          // under the next Lot); false = continue an existing run.
          startNewPartInspection,
          // Round 21: the SPECIFIC run to continue (null = latest / n.a.).
          partRunLot,
          // NOTE (Round 3): the backend now stamps EnteredBy from the
          // login token; this field is kept only for wire compatibility.
          enteredBy: userDetails?.empId || -1,
        });

        if (currentSubmitSeq !== submitSeqRef.current) return;

        const data = response?.data;
        if (!data?.success) {
          setmodaloneerror(data?.errorMessage || "Unable to start inspection.");
          setmodal_center(true);
          return;
        }

        setPartQuantity(`${data.quantity ?? ""}`);
        setVantageNumber(Number(data.revMajor ?? 0));
        setOriginalQuantity(`${data.originalQuantity ?? 0}`);
        setRevMajor(Number(data.revMajor ?? 0));
        setRevMinor(Number(data.revMinor ?? 0));

        // ── Round DI-Country — pin the SERVER-CONFIRMED country ──
        // The response's effectiveCountry is what the backend validated
        // and actually routed to; the workspace keeps it (selection +
        // X-DI-Country session header) so every subsequent DNA/save/
        // close/attachment call stays on the SAME database for the whole
        // inspection lifecycle.
        const confirmedCountry = data.effectiveCountry || targetCountry;
        setSelectedCountry(confirmedCountry);
        setDICountry(confirmedCountry);

        setInspectionData({
          // Round DI-Country: part of the workspace identity — used in
          // the InspectionSection remount key so a country change can
          // never leave previous-country grid state behind.
          country: confirmedCountry,
          jobNum: data.jobNum,
          waveNumber: `${data.waveNumber}`,
          revMajor: data.revMajor,
          revMinor: data.revMinor,
          seq: data.assemblyNumber,
          lotNum: data.lotNum ?? 0,
          enteredBy: data.enteredBy ?? (userDetails?.empId || -1),
          partNum: data.partNumber,
          quantity: data.quantity,
          originalpart: data.originalPart,
          // Round 22 — Part Number LAZY HEADER: no MafiaJobHeader row was
          // created on open; the workspace drives the box layout from
          // `quantity` and creates the header with the FIRST save.
          partHeaderPending: !!data.partHeaderPending,
          onDnaDisplayChange: (v) => setDnaDisplay(v || ""),
          onMetaChange: (m) => setEngineerName(m?.engineer || ""),
          onCloseActionsStateChange: (s) => {
            setCanCloseOp(!!s?.canCloseOp);
            setOpClosed(!!s?.opClosed);
            setCanCloseJob(!!s?.canCloseJob);
            setJobClosed(!!s?.jobClosed);
          },
        });

        setShowInspection(true);
        setSetupCollapsed(true); // cleanup: fold the picker once inspecting

        // ── Round 21/22 — keep the run list in SYNC ──
        // Bust the lookup cache so any re-lookup is fresh. A run is
        // merged into the on-screen list ONLY when it actually exists
        // server-side (header created); a PENDING run (lazy header —
        // nothing saved yet) is not listed anywhere until its first save.
        if (inputOption === "4") {
          requestCacheRef.current.clear();
          if (!data.partHeaderPending) {
            const startedLot = Number(data.lotNum ?? 0);
            const startedWave = Number(data.waveNumber ?? 0);
            const startedQty = Number(data.quantity ?? 0);
            setPartRuns((prev) => {
              const exists = prev.some(
                (r) =>
                  Number(r.lot) === startedLot &&
                  Number(r.wave) === startedWave
              );
              if (exists) return prev;
              return [
                {
                  wave: startedWave,
                  lot: startedLot,
                  quantity: startedQty,
                  closed: false,
                },
                ...prev,
              ];
            });
            setPartModeChoice(String(startedLot));
            setPartModeQty("");
          }
        }
      } catch (error) {
        if (currentSubmitSeq !== submitSeqRef.current) return;
        toast.error(`Error: ${error.message || "Unknown error"}`);
      } finally {
        if (currentSubmitSeq === submitSeqRef.current) {
          setSubmitting(false);
        }
      }
    },
    [
      detailsReady,
      loadingDetails,
      submitting,
      userDetails,
      inputOption,
      inputJob,
      countrycode,
      // Round DI-Country — switch flow inputs:
      selectedCountry,
      detailsCountry,
      showInspection,
      fetchJobDetails,
      AssemblyNumber,
      PartNumber,
      PartOptions,
      selectedLot,
      lotOptions,
      partModeQty, // Part Number mode: Quantity to Inspect
      partRuns, // Round 20: existing runs
      partModeChoice, // Round 20: continue vs new
    ]
  );

  const excelFileToRows = useCallback(async (file) => {
    const data = await file.arrayBuffer();
    const workbook = XLSX.read(data, { type: "array" });
    const sheetName = workbook.SheetNames[0];
    const worksheet = workbook.Sheets[sheetName];
    return XLSX.utils.sheet_to_json(worksheet, { defval: "" });
  }, []);

  const getDnasFromHeaders = useCallback((headers) => {
    const dnaMap = {};
    headers.forEach((h) => {
      const colName = String(h || "").trim();
      if (!colName) return;
      const start = colName.indexOf("[");
      const end = colName.indexOf("]");
      if (start === 0 && end > 0) {
        const inside = colName.substring(1, end);
        if (!isNaN(Number(inside))) {
          const rep = "[" + inside + "]";
          const dna = colName.replace(rep, "").trim();
          dnaMap[colName] = dna;
        }
      }
    });
    return dnaMap;
  }, []);

  const getMeasurementsForHeader = useCallback((rows, dnaHeader) => {
    const measurements = [];
    rows.forEach((row) => {
      const sc = row["Serial Counter"];
      const mt = row["Measurement Time"];
      if (
        sc !== undefined &&
        sc !== null &&
        String(sc).trim() !== "" &&
        !isNaN(Number(sc)) &&
        mt &&
        !isNaN(Date.parse(mt))
      ) {
        measurements.push({
          serial: Number(sc),
          measurementTime: new Date(mt),
          recording: String(row[dnaHeader] ?? "").trim(),
        });
      }
    });
    return measurements;
  }, []);

  const getRequiredNumForDna = useCallback(async (jobQuan, dnaName, mafiaRows) => {
    const row = mafiaRows.find(
      (dr) =>
        String(dr.dnaNum || dr.DnaNum || "")
          .trim()
          .toUpperCase() === String(dnaName || "").trim().toUpperCase()
    );
    if (!row) return 0;

    const dimType = row.dimType || row.DimType || "";
    const toleranceClass = row.toleranceClass || row.ToleranceClass || "";

    // Batch 3 / Round 15 — BUG FIX: this called "di/determine-multiplier",
    // which does not exist (the endpoint lives on the Inspection
    // controller), so every Vision import failed its required-count
    // check with a 404. Corrected to the real route.
    const resp = await api.post("inspection/determine-multiplier", {
      dimType,
      toleranceClass,
      jobQuan,
    });

    if (!(resp.status === 200 || resp.status === 201)) {
      return 0;
    }

    const multiplier = Number(resp.data || 0);

    let result = 0;

    if (multiplier === 0) {
      if (String(dimType || "").toLowerCase().includes("note")) {
        result = -2;
      } else {
        result = 0;
      }
    } else {
      result = Math.ceil(jobQuan * multiplier);
    }

    if (multiplier === 1) {
      return result;
    }
    return result + 2;
  }, []);

  const listOfProblemsWithInputAsync = useCallback(
    async (measurementDict, mafiaRows, jobQuantity, lot) => {
      const problems = [];

      for (const [dnaName, list] of Object.entries(measurementDict)) {
        let validMeasurements = 0;

        for (const m of list) {
          try {
            const v = m.recording;
            if (
              v === null ||
              v === undefined ||
              String(v).trim() === "" ||
              isNaN(Number(v))
            ) {
              const msg = `There are non-numeric (or empty) values within the recordings in DNA ${dnaName}`;
              if (!problems.includes(msg)) problems.push(msg);
            } else {
              validMeasurements += 1;
            }
          } catch {
            const msg = `There are non-numeric (or empty) values within the recordings in DNA ${dnaName}`;
            if (!problems.includes(msg)) problems.push(msg);
          }
        }

        const dnaFound = mafiaRows.some(
          (dr) =>
            String(dr.dnaNum || dr.DnaNum || "")
              .trim()
              .toUpperCase() === String(dnaName || "").trim().toUpperCase()
        );
        if (!dnaFound) {
          problems.push(
            `DNA Number ${dnaName} was identified in the import file, but was not found in the MAFIA table.`
          );
        }

        // Batch 3 / Round 15 — legacy listOfProblemsWithInput rule that
        // the modern port had dropped: every imported DNA must be EMPTY.
        // Message is legacy-verbatim (MDIParent1.vb).
        try {
          const countResp = await api.post("inspection/count-of-entries", {
            JobNum: String(inspectionData?.jobNum ?? ""),
            DnaNum: String(dnaName),
            RevMajor: Number(inspectionData?.revMajor ?? 0),
            RevMinor: Number(inspectionData?.revMinor ?? 0),
            WaveNumber: Number(inspectionData?.waveNumber ?? 0),
            Seq: Number(inspectionData?.seq ?? 0),
            PartNum: String(inspectionData?.partNum ?? ""),
            LotNum: Number(lot ?? 0),
            OrgPartNum: String(
              inspectionData?.originalpart || inspectionData?.partNum || ""
            ),
          });
          const existingCount = Number(countResp?.data ?? 0);
          if (existingCount > 0) {
            problems.push(
              `DNA ${dnaName} already has measurements recorded. The import requires that each DNA imported is empty. Operation aborted.`
            );
          }
        } catch {
          // count lookup failure: fall through; the insert-time closed/
          // duplicate guards still protect the data.
        }

        const numToCheck = await getRequiredNumForDna(jobQuantity, dnaName, mafiaRows);

        if (validMeasurements < numToCheck) {
          const msg = `DNA ${dnaName} requires ${numToCheck.toString()} measurements but the import file has only ${validMeasurements.toString()}`;
          if (!problems.includes(msg)) problems.push(msg);
        }
      }

      return problems;
    },
    [getRequiredNumForDna, inspectionData]
  );

  const onImportExcel = useCallback(async () => {
    if (!showInspection || !inspectionData) {
      toast.info("Start an inspection first.");
      return;
    }

    try {
      const input = document.createElement("input");
      input.type = "file";
      input.accept = ".xlsx,.xls";
      input.click();

      const file = await new Promise((resolve, reject) => {
        input.onchange = () => {
          const f = input.files && input.files[0];
          if (!f) reject(new Error("No file selected"));
          else resolve(f);
        };
        input.onerror = () => reject(new Error("File selection error"));
      });

      const rows = await excelFileToRows(file);

      if (!rows.length) {
        toast.error("The Excel file appears to be empty.");
        return;
      }

      const headers = Object.keys(rows[0] || {});
      const dnaHeaderMap = getDnasFromHeaders(headers);

      if (!Object.keys(dnaHeaderMap).length) {
        toast.error("No DNA columns were found in the Excel file.");
        return;
      }

      const measurementDictionary = {};
      Object.entries(dnaHeaderMap).forEach(([header, dnaName]) => {
        const measurements = getMeasurementsForHeader(rows, header);
        measurementDictionary[dnaName] = measurements;
      });

      const mafiaPayload = {
        partnumber: PartNumber,
        major: revmajor ?? inspectionData?.revMajor,
        minor: revMinor ?? inspectionData?.revMinor,
      };

      const mafiaResp = await api.post("inspection/mafiatable", mafiaPayload);
      if (!(mafiaResp.status === 200 || mafiaResp.status === 201)) {
        throw new Error("MAFIA table not found for this part/rev");
      }
      const mafiaRows = mafiaResp.data || [];

      const originalQty = Number(origquantity || inspectionData.quantity || 0);

      const problems = await listOfProblemsWithInputAsync(
        measurementDictionary,
        mafiaRows,
        originalQty,
        inspectionData.lotNum
      );

      if (problems.length > 0) {
        setmodaloneerror(problems.join("\n"));
        setmodal_center(true);
        return;
      }

      // Round 22 — Part Number LAZY HEADER: the import writes entries via
      // insert-mafia-entry, which does not create headers. If this run's
      // header is still pending (opened, nothing saved yet), create it
      // first with an empty save-inspection call (no entries, no comment
      // — only the idempotent header ensure runs server-side), so the
      // imported readings are never orphaned from the run list.
      if (inspectionData.partHeaderPending) {
        const firstDna = Object.keys(measurementDictionary)[0];
        await api.post("inspection/save-inspection", {
          jobNum: inspectionData.jobNum,
          waveNumber: Number(inspectionData.waveNumber),
          revMajor: inspectionData.revMajor,
          revMinor: inspectionData.revMinor,
          dnaNum: String(firstDna || ""),
          tool: "",
          assemblySeq: Number(inspectionData.seq || 0),
          partNum: inspectionData.partNum,
          orgPartNum: inspectionData.originalpart || inspectionData.partNum,
          lotNum: Number(inspectionData.lotNum || 0),
          enteredBy: Number(userDetails?.empId || -1),
          entries: {},
          comment: null,
          nonConformities: null,
          labels: [],
          knownEntryCount: -1,
          partOnlyHeaderQuantity:
            Number(origquantity || inspectionData.quantity) || 0,
        });
      }

      for (const dnaName of Object.keys(measurementDictionary)) {
        const rowsForDna = mafiaRows.filter(
          (r) =>
            String(r.dnaNum || r.DnaNum || "")
              .trim()
              .toUpperCase() === String(dnaName || "").trim().toUpperCase()
        );

        let passFail = false;
        let min = null;
        let max = null;

        for (const dr of rowsForDna) {
          const method =
            String(dr.methodOfRecording || dr.MethodOfRecording || "").toLowerCase();
          if (method.includes("pass/fail")) {
            passFail = true;
            min = dr.min ?? dr.Min;
            max = dr.max ?? dr.Max;
            break;
          }
        }

        let idx = 1;
        for (const m of measurementDictionary[dnaName]) {
          let value = m.recording;

          if (passFail && min != null && max != null) {
            const num = Number(value);
            if (!isNaN(num) && num >= Number(min) && num <= Number(max)) {
              value = "-777";
            } else {
              value = "-999";
            }
          }

          const payload = {
            jobNum: inspectionData.jobNum,
            dnaNum: dnaName,
            revMajor: inspectionData.revMajor,
            revMinor: inspectionData.revMinor,
            cellNum: idx,
            enteredBy: (userDetails?.empId ?? "-1").toString(),
            enteredDateTime:
              m.measurementTime?.toISOString?.() || new Date().toISOString(),
            waveNumber: Number(inspectionData.waveNumber),
            value,
            tool: "Vision System Import",
            pieceNumber: idx.toString(),
            seq: Number(inspectionData.seq),
            partNum: inspectionData.partNum,
            nonComformityClassification: "",
            scrap: false,
            asIs: false,
            dmr: false,
            lot: Number(inspectionData.lotNum ?? 0),
            orgPartNum: inspectionData.originalpart || inspectionData.partNum,
          };

          await api.post("inspection/insert-mafia-entry", payload);
          idx += 1;
        }
      }

      toast.success("Import Successful");
    } catch (err) {
      toast.error(`General import error: ${err.message || "Unknown error"}`);
    }
  }, [
    showInspection,
    inspectionData,
    excelFileToRows,
    getDnasFromHeaders,
    getMeasurementsForHeader,
    PartNumber,
    revmajor,
    revMinor,
    origquantity,
    listOfProblemsWithInputAsync,
    userDetails,
  ]);

  // Legacy MDIParent1 status strip also showed Quantity, "MAFIA Rev
  // maj-min" and "Created By Engineer: <name>" — restored here.
  const [engineerName, setEngineerName] = useState("");

  const headerContext = useMemo(
    () => ({
      // Round DI-Country — which database the workspace is on ("USA" /
      // "INDIA"); rendered as a flagged "Database" segment in the header
      // so the active country is always visible during an inspection.
      country: inspectionData?.country || selectedCountry,
      inputOption,
      inputJob,
      assembly: AssemblyNumber,
      part: PartNumber,
      waveNumber: wavenumber,
      dnaDisplay,
      quantity: inspectionData?.quantity,
      revMajor: inspectionData?.revMajor,
      revMinor: inspectionData?.revMinor,
      // Round 20 — Part Number mode: run number (Lot) so the header can
      // show "Inspection #" when a part has multiple inspections.
      lotNum: inspectionData?.lotNum,
      engineer: engineerName,
    }),
    [
      inputOption,
      inputJob,
      AssemblyNumber,
      PartNumber,
      wavenumber,
      dnaDisplay,
      inspectionData,
      engineerName,
      selectedCountry, // Round DI-Country
    ]
  );

  const onFileNew = useCallback(async () => {
    // Round DI-2 (Issue 14) — never silently discard entered values: with
    // an open inspection, flush the pending auto-save first; a blocked
    // save keeps the user where they are with the reason shown.
    if (showInspection && inspectionRef.current?.hasUnsavedWork?.()) {
      const ok = await inspectionRef.current?.flushAutoSave?.();
      if (!ok) {
        toast.error(
          "Not cleared — the current DNA could not be saved. Fix the highlighted issues and try again."
        );
        return;
      }
    }
    setEngineerName("");
    setInputOption("");
    setPlaceholder("");
    setInputJob("");
    setDebouncedInputJob("");
    setPartModeQty(""); // Part Number mode
    resetLookupState();
  }, [resetLookupState, showInspection]);

  // ── Round DI-2 (Issue 18) — the in-app Close Inspection flow ──
  // Auto-saves the current DNA (entries + comment — same validation the
  // DNA-switch auto-save enforces: skipped entries / format problems /
  // unclassified out-of-spec values BLOCK the close, keeping the user in
  // the inspection with a reason shown), then clears the active-inspection
  // flag so the tab-close / navigation warnings stop. Never silently
  // closes with unsaved data. Returns true when the inspection is closed.
  const closeActiveInspection = useCallback(async () => {
    if (!showInspection) return true;
    if (closingInspection) return false;
    setClosingInspection(true);
    try {
      const flush = inspectionRef.current?.flushAutoSave;
      const ok = flush ? await flush() : true;
      if (!ok) {
        toast.error(
          "The inspection was not closed — the current DNA could not be saved. Fix the highlighted issues (or classify out-of-spec values) and try again."
        );
        return false;
      }
      setShowInspection(false);
      setInspectionData(null);
      setSetupCollapsed(false);
      setDnaDisplay("");
      toast.success("Inspection closed.");
      return true;
    } finally {
      setClosingInspection(false);
    }
  }, [showInspection, closingInspection]);

  // Leave-modal buttons (Issue 9): "Stay Here" re-arms the Back sentinel
  // when the attempt came from the browser Back button; "Close Inspection"
  // runs the close flow and, on success, completes the original navigation.
  const onLeaveStayHere = useCallback(() => {
    setShowLeaveModal(false);
    if (pendingLeaveBack) {
      try {
        window.history.pushState(
          { diInspectionGuard: true },
          "",
          window.location.href
        );
      } catch {
        /* ignore */
      }
    }
    setPendingLeaveHref(null);
    setPendingLeaveBack(false);
    setPendingLeaveExit(false);
  }, [pendingLeaveBack]);

  const onLeaveCloseInspection = useCallback(async () => {
    const closed = await closeActiveInspection();
    if (!closed) return; // stay — the close flow already explained why
    setShowLeaveModal(false);
    const href = pendingLeaveHref;
    const goBack = pendingLeaveBack;
    const goHome = pendingLeaveExit;
    setPendingLeaveHref(null);
    setPendingLeaveBack(false);
    setPendingLeaveExit(false);
    if (href) {
      navigate(href);
    } else if (goHome) {
      navigate("/");
    } else if (goBack) {
      // The guard's same-URL sentinel entry was already popped when the
      // modal appeared, so one more back completes the user's original
      // back navigation.
      try {
        window.history.back();
      } catch {
        /* ignore */
      }
    }
  }, [
    closeActiveInspection,
    pendingLeaveHref,
    pendingLeaveBack,
    pendingLeaveExit,
    navigate,
  ]);

  // Round DI-2 — File → Exit respects the same rule: with an inspection
  // open it routes through the leave modal instead of leaving directly.
  const onFileExit = useCallback(() => {
    if (showInspection) {
      setPendingLeaveHref(null);
      setPendingLeaveBack(false);
      setPendingLeaveExit(true);
      setShowLeaveModal(true);
      return;
    }
    window.history.back();
  }, [showInspection]);
  const onViewResetLayout = useCallback(
    () => toast.info("Reset Layout (wire later)"),
    []
  );
  const onToolsSettings = useCallback(
    () => toast.info("Tools (wire later)"),
    []
  );
  const onHelpAbout = useCallback(
    () => toast.info("Digital Inspection — Header Menu"),
    []
  );

  const onCloseOp = useCallback(() => {
    if (!showInspection) {
      toast.info("Start an inspection first.");
      return;
    }
    inspectionRef.current?.openCloseOp?.();
  }, [showInspection]);

  const onCloseJob = useCallback(() => {
    if (!showInspection) {
      toast.info("Start an inspection first.");
      return;
    }
    inspectionRef.current?.openCloseJob?.();
  }, [showInspection]);

  const onInspectOneMore = useCallback(() => {
    if (!showInspection) {
      toast.info("Start an inspection first.");
      return;
    }
    inspectionRef.current?.addOneMorePiece?.();
  }, [showInspection]);

  const onPrevDna = useCallback(() => {
    if (!showInspection) return;
    inspectionRef.current?.goPrevDna?.();
  }, [showInspection]);

  const onNextDna = useCallback(() => {
    if (!showInspection) return;
    inspectionRef.current?.goNextDna?.();
  }, [showInspection]);

  const onInspectAll = useCallback(() => {
    if (!showInspection) {
      toast.info("Start an inspection first.");
      return;
    }
    // Batch 2 / Round 9: fills to JOB QUANTITY (legacy AddAll) — the
    // old 21-box cap is gone. (inspectAllTo21 remains as an alias.)
    inspectionRef.current?.inspectAll?.();
  }, [showInspection]);

  // Cleanup: reverse Inspect All from the top toolbar.
  const onClearAdded = useCallback(() => {
    if (!showInspection) {
      toast.info("Start an inspection first.");
      return;
    }
    inspectionRef.current?.clearAddedBoxes?.();
  }, [showInspection]);

  const statusBadge = useMemo(() => {
    if (submitting) return <Badge color="primary">Starting…</Badge>;
    if (loadingDetails) return <Badge color="warning">Loading…</Badge>;
    if (detailsReady) return <Badge color="success">Ready</Badge>;
    return <Badge color="secondary">Not Ready</Badge>;
  }, [loadingDetails, detailsReady, submitting]);

  const closeOpDisabled = !showInspection || !canCloseOp || opClosed;
  const closeJobDisabled = !showInspection || !canCloseJob || jobClosed;

  return (
    <React.Fragment>
      {/* UAT Test 11: without this container no DI toast (skip-entry
          notice, save errors, close-op messages, ...) ever appeared. */}
      <ToastContainer />
      <div className="page-content di-module">
        <Container fluid>
          <MafiaPageHeader
            icon="ri-microscope-line"
            eyebrow="Quality"
            title="Digital Inspection"
            subtitle="Look up a job, confirm part & assembly, then start the inspection workspace."
            tone="teal"
            actions={
              <>
                {statusBadge ? (
                  <span
                    style={{
                      background: "rgba(255,255,255,0.18)",
                      color: "#fff",
                      padding: "6px 12px",
                      fontSize: 12,
                      borderRadius: 999,
                      fontWeight: 500,
                      display: "inline-flex",
                      alignItems: "center",
                    }}
                  >
                    <i className="ri-flashlight-line align-bottom me-1" />
                    {submitting
                      ? "Starting…"
                      : loadingDetails
                      ? "Loading…"
                      : detailsReady
                      ? "Ready"
                      : "Not Ready"}
                  </span>
                ) : null}
              </>
            }
            breadcrumb={[
              { label: "Dashboards", to: "/" },
              { label: "Digital Inspection" },
            ]}
          />

          <div
            style={{
              // Definitive dropdown fix: the DI header was position:sticky
              // with an opaque white background, which painted over the app
              // navbar's profile/logout dropdown when it dropped into the
              // page area. Making it position:relative (not sticky) removes
              // the overlap entirely. The header scrolls with the page like
              // normal content. No z-index needed.
              position: "relative",
              zIndex: 1,
              background: "#fff",
              paddingTop: 6,
              paddingBottom: 6,
              marginBottom: 8,
              borderBottom: "1px solid #eee",
              overflow: "visible",
            }}
          >

            <DIHeaderBar
              context={headerContext}
              onFileNew={onFileNew}
              onFileExit={onFileExit}
              onViewResetLayout={onViewResetLayout}
              onImportExcel={onImportExcel}
              onToolsSettings={onToolsSettings}
              onHelpAbout={onHelpAbout}
              onCloseOp={onCloseOp}
              onCloseJob={onCloseJob}
              closeOpDisabled={closeOpDisabled}
              closeJobDisabled={closeJobDisabled}
              canViewAuditLog={canViewAuditLog}
              onOpenAuditLog={() => {
                // Round DI-2 (Issues 6/17) — the Change Log opens SCOPED to
                // the loaded job / PO; the API rejects unscoped queries for
                // non-admin holders of "DI - Change Log". Navigating away
                // with an inspection open goes through the leave guard so
                // no entered values can be dropped.
                const href = `/di/audit${
                  (inputJob || "").trim()
                    ? `?job=${encodeURIComponent(inputJob.trim())}`
                    : ""
                }`;
                if (showInspection) {
                  setPendingLeaveHref(href);
                  setPendingLeaveBack(false);
                  setPendingLeaveExit(false);
                  setShowLeaveModal(true);
                  return;
                }
                navigate(href);
              }}
            />
          </div>

          <Row style={{ minWidth: 0 }}>
            <Form
              onSubmit={(e) => e.preventDefault()}
              className="w-100 needs-validation"
              action="#"
            >
              <Card style={{ overflow: "hidden" }}>
                <CardBody style={{ minWidth: 0, padding: "12px 14px" }}>
                  <div className="d-flex align-items-center justify-content-between gap-3 mb-2 flex-wrap">
                    <div>
                      <h6 className="mb-0 fw-bold">Job Setup</h6>
                    </div>

                    <div className="d-flex align-items-center gap-2 flex-wrap">
                      {statusBadge}

                      {/* Batch 3 / Round 15 — legacy "-j" engineer mode
                          is now a routed page; read-only MAFIA preview,
                          open to all employees. */}
                      {/* Round DI-1 — Simulator button removed per owner
                          request; the /di/simulator route itself remains
                          for engineers who bookmark it. */}

                      {dnaDisplay ? (
                        <Badge color="info">DNA: {dnaDisplay}</Badge>
                      ) : (
                        <Badge color="light" className="text-muted">
                          DNA: —
                        </Badge>
                      )}

                      {/* Round DI-2 (Issue 4) — "Upload File" moved to the
                          TOP action area, renamed from "Documents". It is
                          job/inspection-context level (not per-DNA) and
                          opens the existing attachments panel. Disabled
                          with a tooltip until a valid inspection context
                          is loaded. */}
                      <span id="uploadFileWrap" style={{ display: "inline-block" }}>
                        <Button
                          color="secondary"
                          outline
                          type="button"
                          id="uploadFileBtn"
                          disabled={!showInspection}
                          style={!showInspection ? { pointerEvents: "none" } : undefined}
                          onClick={() => inspectionRef.current?.toggleDocs?.()}
                        >
                          <i className="ri-attachment-2 align-bottom me-1" />
                          Upload File
                        </Button>
                      </span>
                      <UncontrolledTooltip placement="bottom" target="uploadFileWrap">
                        {showInspection
                          ? "Upload or view files for this job / inspection (files are per job, not per DNA)"
                          : "Select a valid inspection context before uploading files."}
                      </UncontrolledTooltip>

                      {/* Round DI-2 (Issues 9/18) — explicit Close
                          Inspection: auto-saves the current DNA + comment,
                          runs the same checks as the DNA-move auto-save,
                          then clears the active-inspection warnings. */}
                      {showInspection ? (
                        <Button
                          color="danger"
                          outline
                          type="button"
                          id="closeInspectionBtn"
                          disabled={closingInspection}
                          onClick={closeActiveInspection}
                        >
                          <i className="ri-logout-box-r-line align-bottom me-1" />
                          {closingInspection ? "Closing…" : "Close Inspection"}
                        </Button>
                      ) : null}

                      <Button
                        color="primary"
                        outline
                        className="btn btn-soft-primary"
                        id="inspectOneMore"
                        type="button"
                        onClick={onInspectOneMore}
                        disabled={!showInspection}
                      >
                        <img src={add} alt="Add" style={{ width: "17px" }} />
                      </Button>

                      <Button
                        color="primary"
                        outline
                        className="btn btn-soft-primary"
                        id="importExcel"
                        type="button"
                        onClick={onImportExcel}
                      >
                        <img src={excel} alt="Excel" style={{ width: "17px" }} />
                      </Button>

                      <Button
                        color="primary"
                        outline
                        className="btn btn-soft-primary"
                        id="previousDNA"
                        type="button"
                        onClick={onPrevDna}
                        disabled={!showInspection}
                      >
                        <img
                          src={leftarrow}
                          alt="Prev"
                          style={{ width: "17px" }}
                        />
                      </Button>

                      <Button
                        color="primary"
                        outline
                        className="btn btn-soft-primary"
                        id="nextDNA"
                        type="button"
                        onClick={onNextDna}
                        disabled={!showInspection}
                      >
                        <img
                          src={rightarrow}
                          alt="Next"
                          style={{ width: "17px" }}
                        />
                      </Button>

                      <Button
                        color="primary"
                        outline
                        className="btn btn-soft-primary"
                        id="inspectAll"
                        type="button"
                        onClick={onInspectAll}
                        disabled={!showInspection}
                      >
                        <i className="ri-checkbox-multiple-line fs-5 align-middle" title="Inspect All Pieces" /> {/* Round 10 batch — replaces the misleading magnifier-style icon. */}
                      </Button>

                      {/* Cleanup: reverse Inspect All. Removes all added (+)
                          boxes, keeping the real check pieces. */}
                      <Button
                        color="danger"
                        outline
                        className="btn"
                        id="clearAdded"
                        type="button"
                        onClick={onClearAdded}
                        disabled={!showInspection}
                        title="Clear all added (+) boxes"
                      >
                        <i className="ri-eraser-line" />
                      </Button>
                    </div>
                  </div>

                  {/* Cleanup: when a job is loaded, collapse the picker into a
                      one-line summary. Click to expand and change jobs. */}
                  {setupCollapsed ? (
                    <div
                      className="d-flex align-items-center justify-content-between gap-2 mb-2"
                      style={{
                        padding: "6px 10px",
                        background: "#f8f9fb",
                        border: "1px solid #e5e7eb",
                        borderRadius: 8,
                      }}
                    >
                      <span className="text-muted small">
                        Job picker hidden while inspecting.
                      </span>
                      <button
                        type="button"
                        className="di-btn di-btn--ghost"
                        style={{ height: 30 }}
                        onClick={async () => {
                          // Round DI-2 (Issue 14) — flush the pending
                          // auto-save before re-opening the job picker, so
                          // switching context can never drop entered
                          // values; a blocked save keeps the picker closed
                          // with the reason shown.
                          if (inspectionRef.current?.hasUnsavedWork?.()) {
                            const ok = await inspectionRef.current?.flushAutoSave?.();
                            if (!ok) return;
                          }
                          setSetupCollapsed(false);
                        }}
                      >
                        <i className="ri-edit-line me-1" />
                        Change job / settings
                      </button>
                    </div>
                  ) : null}

                  {!setupCollapsed && (
                  <div className="d-flex justify-content-between align-items-start gap-3 mb-3 flex-wrap">
                    {/* Round 22.1 UI alignment: the row is TOP-aligned so
                        every column lines up on the same label line and
                        control line; inline helper texts (MAFIA found /
                        run hint) hang below without pushing their controls
                        out of line (previous align-items-end caused the
                        drift). */}
                    <div style={{ flex: 1, minWidth: 160 }}>
                      <label className="di-field-label text-muted small mb-1">
                        Option
                      </label>
                      <select
                        className="form-select"
                        id="inputOption"
                        value={inputOption || ""}
                        onChange={handleSelectChange}
                        style={{ width: "100%" }}
                      >
                        <option value="">Select option</option>
                        <option value="1">Job Number</option>
                        <option value="2">PO\Line Number</option>
                        {/* Round DI-2.1 — "Job Lot #" REMOVED from the list
                            per owner request. The Job-Lot workflow code
                            (option "3", the Lot dropdown, NewLotModal, the
                            get-lots lookup) is intentionally KEPT intact —
                            only this menu entry is gone, so it can be
                            restored with one line if ever needed. */}
                        {/* Part Number workflow (team request): parts with
                            no Job/PO/Job Lot whose critical characteristics
                            must still be inspected and recorded. */}
                        <option value="4">Part Number</option>
                      </select>
                    </div>

                    <div style={{ flex: 2, minWidth: 200 }}>
                      {/* Round DI-1 — the "Job / PO\Line" header above the
                          entry box was confusing; removed per owner request
                          (the Option dropdown already says which one it is).
                          Part Number mode keeps its label. */}
                      {inputOption === "4" ? (
                        <label className="di-field-label text-muted small mb-1">
                          Part Number
                        </label>
                      ) : null}
                      <Input
                        type="text"
                        className="form-control"
                        id="inputJob"
                        name="inputJob"
                        placeholder={placeholder}
                        value={inputJob}
                        onChange={(e) => setInputJob(e.target.value)}
                      />
                      {/* Round DI-2 (Issues 1/14 — BUG FIX): the DI-1 code
                          SET the invalid job/PO lookup message for every
                          mode but only RENDERED it in Part Number mode, so
                          a wrong Job or PO\Line still failed silently.
                          Errors now render as a clear warning card in ALL
                          modes; Part Number's green "MAFIA found" info line
                          keeps its previous inline style. */}
                      {partLookupMsg?.text && partLookupMsg.type === "error" ? (
                        <div
                          className="alert alert-warning d-flex align-items-start gap-2 py-2 px-3 mt-2 mb-0"
                          role="alert"
                          style={{ fontSize: 13 }}
                        >
                          <i className="ri-error-warning-line align-bottom" />
                          <span>{partLookupMsg.text}</span>
                        </div>
                      ) : inputOption === "4" && partLookupMsg?.text ? (
                        <div className="small text-success mt-1">
                          {partLookupMsg.text}
                        </div>
                      ) : null}
                    </div>

                    {/* ── Part Number mode — inspection run selector (Round 21) ──
                        Shown only when this part already has inspections.
                        EVERY run is listed (newest first) so earlier
                        inspections stay reachable — selecting one continues
                        it (stored quantity reused, saved readings load,
                        quantity box hidden). "Start a new inspection"
                        begins the next run and asks for a quantity. */}
                    {inputOption === "4" && partRuns.length > 0 && (
                      <div style={{ flex: 1.6, minWidth: 260 }}>
                        <label className="di-field-label text-muted small mb-1">
                          Inspection
                        </label>
                        <div className="d-flex gap-2 align-items-start">
                          <select
                            className="form-select"
                            id="partRunSelect"
                            value={partModeChoice || ""}
                            onChange={(e) => setPartModeChoice(e.target.value)}
                          >
                            {dedupedPartRuns.map((run) => (
                              <option key={run.lot} value={String(run.lot)}>
                                {`Inspection #${run.lot + 1} — Qty ${run.quantity}`}
                                {run.startedOn
                                  ? ` — ${formatRunDate(run.startedOn)}`
                                  : ""}
                                {run.entryCount === 0 ? " — empty" : ""}
                                {run.closed ? " (closed)" : ""}
                              </option>
                            ))}
                            <option value="new">+ Start a new inspection…</option>
                          </select>
                          {/* Round 22 — supervisor-only: delete the selected
                              inspection run (readings + comments + header).
                              Backend re-validates the role; this button is
                              convenience visibility only. */}
                          {canDeletePartRun &&
                            partModeChoice !== "new" &&
                            partModeChoice !== "" && (
                            <Button
                              color="danger"
                              outline
                              type="button"
                              title="Delete this inspection (supervisor only)"
                              style={{ height: 38, flex: "0 0 auto" }}
                              disabled={deletingPartRun}
                              onClick={() => setShowDeleteRunConfirm(true)}
                            >
                              <i className="ri-delete-bin-line" />
                            </Button>
                          )}
                        </div>
                        <div className="small text-muted mt-1">
                          {partModeChoice === "new"
                            ? "A new inspection will begin — enter the quantity to inspect. Earlier inspections are kept and stay selectable here."
                            : "Saved readings of the selected inspection will load."}
                        </div>
                      </div>
                    )}

                    {/* Part Number mode ONLY: "Quantity to Inspect". These
                        parts have no Job/PO, so Epicor cannot supply a
                        quantity. Positive integer; re-validated server-side.
                        Shown only when a FRESH run needs it: first-ever
                        inspection of the part, or "Start a new inspection"
                        selected — never when continuing. */}
                    {inputOption === "4" &&
                      (partRuns.length === 0 || partModeChoice === "new") && (
                      <div style={{ flex: 1, minWidth: 150 }}>
                        <label
                          className="di-field-label text-muted small mb-1"
                          style={{ whiteSpace: "nowrap" }}
                        >
                          Quantity to Inspect
                        </label>
                        <Input
                          type="number"
                          min={1}
                          step={1}
                          inputMode="numeric"
                          className="form-control"
                          id="partModeQty"
                          name="partModeQty"
                          placeholder="e.g., 10"
                          value={partModeQty}
                          onChange={(e) => setPartModeQty(e.target.value)}
                        />
                      </div>
                    )}

                    {/* Batch 2 / Round 7 — legacy cboJobLot. Visible only in
                        Job-Lot mode; first item is "New Lot #" (opens the
                        frmLotNum-equivalent modal), followed by existing
                        lots from the server. */}
                    {inputOption === "3" && (
                      <div style={{ flex: 1, minWidth: 140 }}>
                        <label className="di-field-label text-muted small mb-1">Lot #</label>
                        <select
                          className="form-select"
                          id="inputJobLot"
                          value={selectedLot || ""}
                          onChange={(e) => {
                            const v = e.target.value;
                            if (v === NEW_LOT_SENTINEL) {
                              // Legacy cboJobLot_SelectedIndexChanged:
                              // picking "New Lot #" opens frmLotNum.
                              setShowNewLotModal(true);
                              return;
                            }
                            setSelectedLot(v);
                          }}
                        >
                          <option value="">Select lot...</option>
                          <option value={NEW_LOT_SENTINEL}>{NEW_LOT_SENTINEL}</option>
                          {lotOptions.map((lot) => (
                            <option key={lot} value={lot}>
                              {lot}
                            </option>
                          ))}
                        </select>
                      </div>
                    )}

                    <div className="d-flex flex-wrap align-items-start gap-3" style={{ flex: 3 }}>
                      {/* ── Round DI-Country — dual database groups restored ──
                          Legacy MDIParent1 toolbar parity: USA In Process /
                          USA Quality / India In Process / India Quality —
                          every DI user could click either country's buttons
                          (the legacy btnIndia / btnUSA cross-buttons had no
                          per-user restriction), so both groups render for
                          everyone; the backend validates the value and
                          enforces module access. The group matching the
                          current selection is highlighted; clicking a button
                          in the OTHER group switches the database
                          (save-flush + state reset + fresh lookup — see
                          handleSubmit). Groups wrap and stack cleanly on
                          narrow screens (flex-wrap). */}
                      <div
                        className={`di-db-group${
                          selectedCountry === "USA" ? " di-db-group--active" : ""
                        }`}
                      >
                        <label
                          className="di-field-label text-muted small mb-1 d-block"
                          style={{ whiteSpace: "nowrap" }}
                        >
                          <img src={usflag} alt="USA" style={{ width: "14px", marginRight: "4px" }} />
                          USA Database
                        </label>
                        <div className="d-flex gap-2" role="group" aria-label="USA inspection type">
                          <button
                            className="di-wave-tile"
                            type="button"
                            id="usainprog"
                            disabled={
                              submitting ||
                              (selectedCountry === "USA" &&
                                (!detailsReady || loadingDetails))
                            }
                            onClick={(e) => handleSubmit(e, "USA", "1")}
                          >
                            In Progress
                            <small>Wave 1 · CNC</small>
                          </button>
                          <button
                            className="di-wave-tile"
                            type="button"
                            id="usaqual"
                            disabled={
                              submitting ||
                              (selectedCountry === "USA" &&
                                (!detailsReady || loadingDetails))
                            }
                            onClick={(e) => handleSubmit(e, "USA", "2")}
                          >
                            Quality
                            <small>Wave 2 · Final</small>
                          </button>
                        </div>
                      </div>

                      <div
                        className={`di-db-group${
                          selectedCountry === "INDIA" ? " di-db-group--active" : ""
                        }`}
                      >
                        <label
                          className="di-field-label text-muted small mb-1 d-block"
                          style={{ whiteSpace: "nowrap" }}
                        >
                          <img src={indiaflag} alt="India" style={{ width: "14px", marginRight: "4px" }} />
                          India Database
                        </label>
                        <div className="d-flex gap-2" role="group" aria-label="India inspection type">
                          <button
                            className="di-wave-tile"
                            type="button"
                            id="indiainprog"
                            disabled={
                              submitting ||
                              (selectedCountry === "INDIA" &&
                                (!detailsReady || loadingDetails))
                            }
                            onClick={(e) => handleSubmit(e, "INDIA", "1")}
                          >
                            In Progress
                            <small>Wave 1 · CNC</small>
                          </button>
                          <button
                            className="di-wave-tile"
                            type="button"
                            id="indiaqual"
                            disabled={
                              submitting ||
                              (selectedCountry === "INDIA" &&
                                (!detailsReady || loadingDetails))
                            }
                            onClick={(e) => handleSubmit(e, "INDIA", "2")}
                          >
                            Quality
                            <small>Wave 2 · Final</small>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  )}

                  <UncontrolledTooltip placement="bottom" target="inspectOneMore">
                    Inspect one more piece
                  </UncontrolledTooltip>
                  <UncontrolledTooltip placement="bottom" target="importExcel">
                    Import from Vision System Excel File
                  </UncontrolledTooltip>
                  <UncontrolledTooltip placement="bottom" target="previousDNA">
                    Previous DNA
                  </UncontrolledTooltip>
                  <UncontrolledTooltip placement="bottom" target="nextDNA">
                    Next DNA
                  </UncontrolledTooltip>
                  <UncontrolledTooltip placement="bottom" target="inspectAll">
                    Inspect all pieces
                  </UncontrolledTooltip>

                  <NewLotModal
                    open={showNewLotModal}
                    existingLots={lotOptions}
                    onCancel={() => setShowNewLotModal(false)}
                    onConfirm={(lotNum) => {
                      // Legacy parity: the new lot is added to the dropdown
                      // and selected; it is PERSISTED only when the
                      // inspection starts (InsertHeader writes the lot row).
                      setLotOptions((prev) =>
                        prev.includes(String(lotNum)) ? prev : [...prev, String(lotNum)]
                      );
                      setSelectedLot(String(lotNum));
                      setShowNewLotModal(false);
                    }}
                  />

                  <Modal
                    isOpen={showDeleteRunConfirm}
                    toggle={() => setShowDeleteRunConfirm(false)}
                    centered
                  >
                    <ModalHeader toggle={() => setShowDeleteRunConfirm(false)}>
                      <i className="ri-delete-bin-line align-bottom me-2 text-danger" />
                      Delete Inspection
                    </ModalHeader>
                    <ModalBody>
                      {(() => {
                        const lot = Number(partModeChoice);
                        const run = dedupedPartRuns.find(
                          (r) => r.lot === lot
                        );
                        return (
                          <div className="text-muted">
                            This will permanently delete{" "}
                            <b>
                              Inspection #{Number.isInteger(lot) ? lot + 1 : "?"}
                            </b>
                            {run ? ` (Quantity ${run.quantity}` : ""}
                            {run?.startedOn
                              ? `, started ${formatRunDate(run.startedOn)})`
                              : run
                              ? ")"
                              : ""}{" "}
                            for part <b>{PartNumber || inputJob}</b> —
                            including all saved readings and comments. This
                            cannot be undone. Continue?
                          </div>
                        );
                      })()}
                    </ModalBody>
                    <div className="modal-footer">
                      <Button
                        color="light"
                        onClick={() => setShowDeleteRunConfirm(false)}
                        disabled={deletingPartRun}
                      >
                        No
                      </Button>
                      <Button
                        color="danger"
                        onClick={deleteSelectedPartRun}
                        disabled={deletingPartRun}
                      >
                        <i className="ri-delete-bin-line align-bottom me-1" />
                        {deletingPartRun ? "Deleting..." : "Yes, delete"}
                      </Button>
                    </div>
                  </Modal>

                  {/* Round DI-2 (Issue 9) — controlled leave guard while an
                      inspection is open (legacy Error 32 parity for in-app
                      navigation; browser tab close/refresh is covered by
                      the native beforeunload prompt above). */}
                  <Modal
                    isOpen={showLeaveModal}
                    toggle={onLeaveStayHere}
                    centered
                    backdrop="static"
                  >
                    <ModalHeader toggle={onLeaveStayHere}>
                      <i className="ri-error-warning-line align-bottom me-2 text-warning" />
                      Inspection Open
                    </ModalHeader>
                    <ModalBody>
                      <div className="text-muted">
                        Please close the active inspection before leaving this
                        page. Closing will auto-save the current DNA&apos;s
                        entries and comments first.
                      </div>
                    </ModalBody>
                    <div className="modal-footer">
                      <Button color="light" onClick={onLeaveStayHere}>
                        Stay Here
                      </Button>
                      <Button
                        color="primary"
                        onClick={onLeaveCloseInspection}
                        disabled={closingInspection}
                      >
                        <i className="ri-logout-box-r-line align-bottom me-1" />
                        {closingInspection ? "Closing…" : "Close Inspection"}
                      </Button>
                    </div>
                  </Modal>

                  <Modal isOpen={modal_center} toggle={tog_center} centered>
                    <ModalHeader className="modal-title" />
                    <ModalBody className="text-center p-5">
                      <lord-icon
                        src="https://cdn.lordicon.com/tdrtiskw.json"
                        trigger="loop"
                        colors="primary:#f7b84b,secondary:#405189"
                        style={{ width: "130px", height: "130px" }}
                      ></lord-icon>
                      <div className="mt-4">
                        <h4 className="mb-3" style={{ whiteSpace: "pre-line" }}>
                          {modaloneerror}
                        </h4>
                        <div className="hstack gap-2 justify-content-center">
                          <Button
                            color="danger"
                            onClick={() => setmodal_center(false)}
                          >
                            Close
                          </Button>
                        </div>
                      </div>
                    </ModalBody>
                  </Modal>

                  {showInspection && inspectionData && (
                    <div style={{ marginTop: 14, minWidth: 0 }}>
                      {/* Round 21: keyed by the full inspection context so
                          switching between part-mode runs (or waves/jobs)
                          remounts the workspace — no state from the
                          previous run can linger in the grid. Round
                          DI-Country: the COUNTRY is part of that identity
                          too, so a USA→India (or India→USA) switch always
                          remounts and no previous-country state survives. */}
                      <InspectionSection
                        key={`${inspectionData.country}|${inspectionData.jobNum}|${inspectionData.waveNumber}|${inspectionData.lotNum}|${inspectionData.seq}|${inspectionData.partNum}|${inspectionData.revMajor}-${inspectionData.revMinor}`}
                        ref={inspectionRef}
                        {...inspectionData}
                      />
                    </div>
                  )}
                </CardBody>
              </Card>
            </Form>
          </Row>
        </Container>
      </div>

      <style>{`
        @media (max-width: 900px) {
          .page-content .card-body > div[style*="gridTemplateColumns"] {
            grid-template-columns: 1fr !important;
          }
        }
      `}</style>
    </React.Fragment>
  );
};

export default DI;